import { TRoute } from "@/shared/types/route.ts";
import SettingsLayout from "@/settings/pages/settings-layout.tsx";
import SettingsOverview from "@/settings/pages/settings-overview.tsx";
import OrganizationSettings from "@/settings/pages/organization-settings.tsx";
import UserSettings from "@/settings/pages/user-settings.tsx";
import UserDetail from "@/settings/pages/user-detail.tsx";
import LocationSettings from "@/settings/pages/location-settings.tsx";
import MachineSettings from "@/settings/pages/machine-settings.tsx";
import TaxonomySettings from "@/settings/pages/taxonomy-settings.tsx";
import PreferencesSettings from "@/settings/pages/preferences-settings.tsx";
import { SETTINGS_URL } from "@/settings/config/settings-urls";

const SETTINGS_ROOT_ROUTE: TRoute = {
  name: "Settings",
  path: SETTINGS_URL.ROOT,
  component: SettingsLayout,
  roles: [],
  routes: [
    {
      name: "Settings Overview",
      path: "",
      component: SettingsOverview,
      roles: [],
    },
    {
      name: "Organization Settings",
      path: "organization",
      component: OrganizationSettings,
      roles: [],
    },
    {
      name: "User Settings",
      path: "user/add",
      component: UserSettings,
      roles: [],
    },
    {
      name: "User Detail",
      path: "user/:id?",
      component: UserDetail,
      roles: [],
    },
    {
      name: "Location Settings",
      path: "location/:id?",
      component: LocationSettings,
      roles: [],
    },
    {
      name: "Machine Settings",
      path: "machine/:id?",
      component: MachineSettings,
      roles: [],
    },
    {
      name: "Taxonomy Settings",
      path: "taxonomy",
      component: TaxonomySettings,
      roles: [],
    },
    {
      name: "Preferences",
      path: "preferences",
      component: PreferencesSettings,
      roles: [],
    },
  ],
};

const SETTINGS_ROUTES = {
  SETTINGS_ROOT_ROUTE,
} as const;

export { SETTINGS_URL, SETTINGS_ROUTES };
